import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { lightText } from "../../constants/colors";
import ImageCarousel from "../../components/slider";
import axios from "axios";
import { baseUrl } from "../../utills";
import { useGeneralInfo } from "../../context/generalContext";
const FeaturedCars = ({fetchCarPosts}) => {
  const token = localStorage.getItem("access_token");
const [featuredCars, setFeaturedCars]=useState([]);
const [generalInfo] = useGeneralInfo();
console.log("generalInfo in featured car:",generalInfo?.cars);
const [matchingCars, setMatchingCars] = useState([]);

useEffect(() => {
  if (generalInfo?.cars?.length > 0 && featuredCars.length > 0) {
    const generalCarIds = new Set(featuredCars.map((car) => Number(car.car_post_id)));

    console.log("generalCarIds...", generalCarIds);
    console.log("featuredCars IDs:", featuredCars.map((car) => Number(car.car_post_id)));

    const matched = generalInfo.cars.filter((car) => generalCarIds.has(Number(car?.id)));

    console.log("matched:", matched);
    setMatchingCars(matched);
  }
}, [generalInfo.cars, featuredCars]);

console.log("matchingCars:",matchingCars);

  const getFeatures= async()=>{
    const payload={
      car_post_id:"",
      user_id:"",

    }
    try {
      const res = await axios.get(baseUrl+"featured-post-logs/",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(res.status===200){
        setFeaturedCars(res?.data)
      }
      console.log("feature cars:",res);
      
    } catch (error) {
      
    }
  }
  useEffect(()=>{
    getFeatures();
  },[])
  return (
    <div
      className="lg:w-[1450px]"
      style={{
        // width: "1450px",
        margin: "0 auto",
        marginTop: "80px",
      }}
    >
      <div className="mb-20 lg:mb-8 ms-4 md:ms-16">
        <p className="text-[40px] font-bold">Featured Cars</p>
        <p style={{ color: lightText }}>
          Here are some of the featured cars in different categories
        </p>
      </div>
      <ImageCarousel data={matchingCars} fetchCarPosts={fetchCarPosts} />
    </div>
  );
};

export default FeaturedCars;
